export default __webpack_public_path__ + "static/media/T21.db2292ac.JPG";